import FacebookWidget from '@/components/widgets/facebook/index.vue';
import GoogleWidget from '@/components/widgets/google/index.vue';
export default {
  name: "sync-social",
  components:{
    FacebookWidget,
    GoogleWidget
  }
}